import { render, staticRenderFns } from "./YearwiseEfficiencyList.vue?vue&type=template&id=5fa83e4e"
import script from "./YearwiseEfficiencyList.vue?vue&type=script&lang=js"
export * from "./YearwiseEfficiencyList.vue?vue&type=script&lang=js"
import style0 from "./YearwiseEfficiencyList.vue?vue&type=style&index=0&id=5fa83e4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports